__turbopack_context__.v({
  "address": "WalletReceive-module__9q-kJq__address",
  "cancelButton": "WalletReceive-module__9q-kJq__cancelButton",
  "copyButton": "WalletReceive-module__9q-kJq__copyButton",
  "copyButtonContainer": "WalletReceive-module__9q-kJq__copyButtonContainer",
  "description": "WalletReceive-module__9q-kJq__description",
  "header": "WalletReceive-module__9q-kJq__header",
  "qrCode": "WalletReceive-module__9q-kJq__qrCode",
  "qrContainer": "WalletReceive-module__9q-kJq__qrContainer",
  "qrFooter": "WalletReceive-module__9q-kJq__qrFooter",
  "receive": "WalletReceive-module__9q-kJq__receive",
  "root": "WalletReceive-module__9q-kJq__root",
  "sendRcvIconContainer": "WalletReceive-module__9q-kJq__sendRcvIconContainer",
});
